import moment from 'moment-timezone';
import { Membership } from '../membership';

/** Submitted form requests can have approvals (one or more) */
export class FormSubmissionApproval
{
    id: number;
    formApproverId: number;
    formSubmissionId: number;
    approves: boolean;
    denies: boolean;
    createdAt: moment.Moment;
    canApprove: boolean;
    canReset: boolean;
    membership: Membership;
    approverDeleted: boolean;

    constructor(request: any) {
        this.id = request.id;
        this.formApproverId = request.formApproverId;
        this.formSubmissionId = request.formSubmissionId;
        this.approves = request.approves;
        this.denies = request.denies;
        this.canApprove = request.canApprove;
        this.canReset = request.canReset;
        this.approverDeleted = request.approverDeleted;

        if (request.createdAt) {
            this.createdAt = moment(request.createdAt);
        }

        if (request.membership) {
            this.membership = request.membership;
        }
    }
}

/**
 * The approvals that belong on a request's record: every current approver, plus each removed approver
 * who had already approved or denied, because that vote is part of how the request was decided (SD-10598).
 * A removed approver who never responded drops off. A removed seat whose member still holds a current
 * seat (or a second removed seat for the same member) is skipped, so nobody is counted twice. Core's
 * RequestInboxService counts the list row's "X of Y" by the same rule.
 */
export function recordedApprovals(approvals: FormSubmissionApproval[]): FormSubmissionApproval[] {
    const counted = new Set(approvals.filter((a) => !a.approverDeleted).map((a) => a.membership?.id));
    return approvals.filter((a) => {
        if (!a.approverDeleted) {
            return true;
        }
        if (!(a.approves || a.denies) || counted.has(a.membership?.id)) {
            return false;
        }
        counted.add(a.membership?.id);
        return true;
    });
}
